import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { z } from 'zod'
import {
  GROUP_DETAIL_TABS,
  GroupDetailScreen,
  type GroupDetailTab,
} from '@/features/groups/group-detail'

export const groupDetailSearchSchema = z.object({
  tab: z.enum(GROUP_DETAIL_TABS).optional().default('overview'),
})

/**
 * Route shell for one group's detail (plans/58 D-17) — its companies, plan and
 * entitlements, support sessions, and the suspend/reactivate pair.
 *
 * The platform API authorises every request independently, so this shell adds
 * no grant guard: another operator's view of the same URL is whatever
 * `GET /platform/groups` already allowed them.
 */
export const Route = createFileRoute('/_authenticated/groups/$groupId/')({
  validateSearch: groupDetailSearchSchema,
  component: GroupDetailRoute,
})

function GroupDetailRoute() {
  const { groupId } = Route.useParams()
  const search = Route.useSearch()
  const navigate = useNavigate()

  return (
    <GroupDetailScreen
      groupId={groupId}
      tab={search.tab}
      onTabChange={(tab: GroupDetailTab) =>
        void navigate({ to: '/groups/$groupId', params: { groupId }, search: { tab } })
      }
    />
  )
}
